import moment from 'moment'

export function isObservedDaysWithinDateRange (dateArray, dateRange = []) {
  if (!dateArray || dateArray.length === 0) return false

  if (!dateRange || dateRange.length === 0) return false

  const [rangeStart, rangeEnd] = dateRange

  const firstDate = moment.utc(dateArray[0], 'YYYY-MM-DD').toDate()
  const lastDate = moment.utc(dateArray[dateArray.length - 1], 'YYYY-MM-DD').toDate()

  return (
    firstDate.getTime() >= rangeStart.getTime()
    && lastDate.getTime() <= rangeEnd.getTime()
  )
}
